/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var gettext = require('mag-gettext').gettext;

module.exports = [
    {value: 18, name: gettext('Small')},
    {value: 20, name: gettext('Normal')},
    {value: 23, name: gettext('Large')},
    {value: 26, name: gettext('Huge')}
];
